import BaseAPI from '../api'
const path = 'folders'
export interface ListFolderInterface {
    keywordLevel1?: string;
    keywordLevel2?: string;
    keywordLevel3?: string;
    keywordLevel4?: string;
    idDepartment?: string;
    idFiscalYear?: string;
    startDate?: string;
    endDate?: string;
    sortBy?: string;
    sortType?: string;
}
export interface CreateFolderInterface {
    folderName: string
    folderLocation?: string
    idFiscalyear?: number
    idDepartment?: number
    idReferFolder?: number
}


export default class FolderApi extends BaseAPI {

    static getSharedFolders(props: ListFolderInterface): Promise<any> {
        return this.api.get(`shared-folders`, { params: { ...props } })
            .then((res) => res)
    }
    static getMyFolders(props: ListFolderInterface): Promise<any> {
        return this.api.get(`my-folders`, { params: { ...props } })
            .then((res) => res)
    }
    static postFolder(props: CreateFolderInterface): Promise<any> {
        return this.api.post(`${path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchFolder(idFolder: number, props: CreateFolderInterface): Promise<any> {
        return this.api.patch(`${path}/${idFolder}`, { ...props }, {})
            .then((res) => res)
    }
    static patchFolderDelete(idFolder?: number): Promise<any> {
        return this.api.patch(`${path}/${idFolder}/delete`, {})
            .then((res) => res)
    }
    static getSharedFolder(idFolder: number, props?: ListFolderInterface): Promise<any> {
        return this.api.get(`shared-folders/${idFolder}`, { params: { ...props } })
            .then((res) => res)
    }
    static getMyFolder(idFolder: number, props?: ListFolderInterface): Promise<any> {
        return this.api.get(`my-folders/${idFolder}`, { params: { ...props } })
            .then((res) => res)
    }
    static getFolderName(): Promise<any> {
        return this.api.get(`folders-name`, {})
            .then((res) => res)
    }
    static getFolderDownload(idFolder?: number): Promise<any> {
        return this.api.get(`${path}/${idFolder}/download`, {
            responseType: 'arraybuffer'
        }).then((res) => res)
    }
    static patchPermissionFolder(idFolder: number, props: any): Promise<any> {
        return this.api.patch(`${path}/${idFolder}/permission`, { ...props })
            .then((res) => res)
    }
    static getPermissionFolder(idFolder: number,): Promise<any> {
        return this.api.get(`${path}/${idFolder}/permission`, {})
            .then((res) => res)
    }
    static patchFormDocument(idFolder: number, props: any): Promise<any> {
        return this.api.patch(`${path}/${idFolder}/form-document`, { ...props })
            .then((res) => res)
    }
    static getFormDocument(idFolder: number,): Promise<any> {
        return this.api.get(`${path}/${idFolder}/form-document`, {})
            .then((res) => res)
    }
    static getDocumentType(): Promise<any> {
        return this.api.get(`document-type`, {})
            .then((res) => res)
    }
    static getDocumentSize(): Promise<any> {
        return this.api.get(`document-size`, {})
            .then((res) => res)
    }

    static postImportIndex(idFolder: number, formData: any): Promise<any> {
        return this.api.post(`${path}/${idFolder}/import-index`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        })
            .then((res) => res)
    }
}
